var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "new-ring-main-header" } }, [
    _c("div", { staticClass: "nav-left" }, [
      _c("div", { staticClass: "title" }, [
        _c(
          "span",
          { staticClass: "new-ui__header__title" },
          [
            _vm._t("default", function () {
              return [_vm._v("[MENU NAME]")]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-title" }, [
        _vm._v("\n      " + _vm._s(_vm.headerSubTitle) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.isAccountLocked
        ? _c(
            "span",
            {
              staticStyle: {
                display: "block",
                "padding-top": "2px",
                "font-size": "large",
                color: "red",
                "font-weight": "500",
              },
            },
            [_vm._v("\n      ACCOUNT IS DISABLED!\n    ")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nav-right" }, [
      _c("ul", { staticClass: "nav-form" }, [
        _vm.showOneOffButton ? _c("li", [_c("one-off-button")], 1) : _vm._e(),
        _vm._v(" "),
        _vm.showPlcButton ? _c("li", [_c("plc-button")], 1) : _vm._e(),
        _vm._v(" "),
        _c("li", [_c("main-search")], 1),
        _vm._v(" "),
        _c("li", [_c("user-options")], 1),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }